var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #565d6d;\n      }\n\n      .cls-3 {\n        fill: #565d6d;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n        stroke-width: 1.7px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.72,
    y: 2.18,
    width: 16.56,
    height: 17.05,
    rx: 2.25,
    ry: 2.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.56,12.41c0,.34-.25.58-.54.59-.32,0-.58-.23-.58-.57v-.65s-.6,0-.6,0c-.34,0-.59-.23-.6-.56,0-.31.23-.58.57-.58h1.95c.27,0,.48-.23.49-.48.01-.24-.18-.51-.45-.51h-1.57c-.93-.02-1.63-.83-1.58-1.73.05-.93.85-1.63,1.8-1.54v-.64c0-.33.24-.57.55-.58.32,0,.58.24.58.58v.63s.64,0,.64,0c.32,0,.56.26.56.56,0,.3-.24.57-.57.57h-1.94c-.27,0-.48.23-.49.49,0,.26.21.5.49.51h1.54c.93.01,1.62.83,1.57,1.73-.06.93-.85,1.61-1.8,1.53v.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.69,15.08H4.31c-.35,0-.59-.24-.59-.57,0-.3.23-.57.57-.57h11.42c.34,0,.57.27.56.57,0,.32-.25.57-.59.57h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.34,17.51h-7.27c-.33,0-.55-.29-.55-.57,0-.31.25-.56.58-.56h7.18c.32,0,.55.23.57.52.02.27-.17.61-.52.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.6,1.02v2.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.2,1.02v2.77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.8,1.02v2.77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.4,1.02v2.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.6379f42a8395702c4da307ab09f83e84.svg";
export { ForwardRef as ReactComponent };